// src/components/agenda/MarcaRecordatorio.js
// Etiqueta pequeña de la cita según el recordatorio por correo: «Confirmada»
// si el paciente pulsó el botón, «Anulada por el paciente» si la anuló, y
// «Aviso enviado» mientras no contesta.
import React from 'react';

const ESTILOS = {
    confirmada: { texto: 'Confirmada', titulo: 'El paciente ha confirmado la cita desde el correo', clase: 'bg-emerald-500/10 text-emerald-700 border-emerald-200' },
    cancelada: { texto: 'Anulada por el paciente', titulo: 'El paciente ha anulado la cita desde el correo', clase: 'bg-rose-500/10 text-rose-700 border-rose-200' },
    enviado: { texto: 'Aviso enviado', titulo: 'Se le ha mandado el recordatorio por correo y aún no ha contestado', clase: 'bg-slate-500/10 text-slate-600 border-slate-200' }
};

export default function MarcaRecordatorio({ cita, grande = false }) {
    const r = cita?.recordatorio;
    if (!r) return null;
    const clave = r.respuesta || (r.enviado ? 'enviado' : null);
    if (!clave || !ESTILOS[clave]) return null;
    // Una cita que ya está en curso o atendida no necesita el aviso
    if (clave === 'enviado' && cita.estado !== 'pendiente') return null;
    const e = ESTILOS[clave];
    return (
        <span title={e.titulo}
              className={`inline-block border rounded font-black uppercase tracking-wide truncate ${grande ? 'text-[10px] px-2 py-0.5' : 'text-[8px] px-1.5 py-0.5'} ${e.clase}`}>
            {e.texto}
        </span>
    );
}
